import { createSlice } from '@reduxjs/toolkit';
import { useSelector } from 'react-redux';

const initialState: { access: any } = {
	access: '',
};

export const sessionSlice = createSlice({
	name: 'session',
	initialState,
	reducers: {
		clearSession: (state) => {
			state.access = null;
		},
		setAccessToken: (state, action: { payload: any }) => {
			state.access = action.payload;
		},
	},
});

export const { setAccessToken, clearSession } = sessionSlice.actions;

export const useCurrentAccessTokenSelector = () =>
	useSelector((state: any) => state.session.access);
